<script lang="ts">
  import { ResponsiveVars } from '@twist/core';
  import { cx } from '@emotion/css';
  import { modals } from '$lib/stores/modals';
  import { Accessibility } from '$components/Icons';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  // After launch of block-web-global-nav, this color will always be black and this prop can be removed entirely
  // Additionally, background color will only be white
  // Only the styling of class:default should remain
  export let color: 'white' | 'black' = 'white';

  $: globalNavEnabled = flagValue(FEATURE_FLAGS.GLOBAL_NAV);

  let button: HTMLButtonElement;

  const responsiveVars = new ResponsiveVars()
    .addFluid('toggle-py', [
      ['min', 7],
      ['min', 'lg', 7, 14],
      ['lg', 'max', 7, 14],
      ['max', 14]
    ])
    .addFluid('toggle-px', [
      ['min', 8],
      ['min', 'lg', 8, 16],
      ['lg', 'max', 8, 16],
      ['max', 16]
    ])
    .addFluid('icon-height', [
      ['min', 17],
      ['min', 'lg', 17, 33],
      ['lg', 'max', 16, 22.67],
      ['max', 22.67]
    ])
    .addFluid('icon-width', [
      ['min', 14],
      ['min', 'lg', 14, 29],
      ['lg', 'max', 14, 18.67],
      ['max', 18.67]
    ])
    .toCSS();
</script>

<button
  bind:this={button}
  class={cx(responsiveVars, 'modal-toggle', {
    'color-black': color === 'black',
    default: globalNavEnabled
  })}
  aria-label="Open accessibility settings"
  on:click={() => modals.open('accessibility', button)}
  data-testid="accessibility-modal-button"
>
  <div class="icon">
    <Accessibility />
  </div>
</button>

<style lang="scss">
  .modal-toggle {
    cursor: pointer;
    display: flex;

    border: none;

    border-radius: 1000px;
    padding: var(--toggle-py) var(--toggle-px);

    outline: none;
    color: #fff;
    background-color: transparent;

    &:hover,
    &:focus-visible {
      color: #000;
      background-color: #fff;
    }

    &.color-black {
      color: #000;

      &:hover,
      &:focus-visible {
        color: #fff;
        background-color: #000;
      }
    }

    &.default {
      color: #000;

      &:hover,
      &:focus-visible {
        outline: 1px solid var(--twist-color-gray-100);
        background: none;
      }
    }
  }

  .icon {
    display: flex;
    justify-content: center;
    height: var(--icon-height);
    width: var(--icon-width);
  }
</style>
